import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { Button } from "./ui/button";
import Image from "next/image";

const features = [
  {
    category: "Documentation Management",
    title: "Create and Publish Documentation Easily",
    details:
      "Docloo enables users to create, manage, and publish documentation seamlessly. Organize your content efficiently and share it with your audience effortlessly.",
    tutorialLink: "#",
    imageSrc: "https://docloo-public.lon1.cdn.digitaloceanspaces.com/95eaed36-7818-44f3-8558-6187c1890e0d.webp"
  },
  {
    category: "Job Management",
    title: "Streamline Job Postings and Applications",
    details:
      "Manage job postings efficiently with Docloo. Post job listings, track applications, and streamline hiring processes in one place.",
    tutorialLink: "#",
    imageSrc: "https://docloo-public.lon1.cdn.digitaloceanspaces.com/General-Manager-Job-Description-Template-e1654003433677.jpg"
  },
  {
    category: "Custom Domains",
    title: "Personalize Your Documentation Space",
    details:
      "Use custom domains to enhance branding and provide a unique experience for your users. Docloo ensures a professional and personalized documentation platform.",
    tutorialLink: "#",
    imageSrc: "https://docloo-public.lon1.cdn.digitaloceanspaces.com/Marketing_IG-Mini-Stories_Site_0821-2.png"
  },
  {
    category: "Collaboration Tools",
    title: "Enhance Teamwork with Shared Workspaces",
    details:
      "Enable seamless collaboration with your team using Docloo’s shared workspaces. Manage roles, permissions, and content efficiently.",
    tutorialLink: "#",
    imageSrc: "https://docloo-public.lon1.cdn.digitaloceanspaces.com/960x0.webp"
  },
  {
    category: "Analytics & Insights",
    title: "Track Documentation Engagement and Performance",
    details:
      "Gain valuable insights into how your documentation is being used. Monitor views, interactions, and optimize content for better engagement.",
    tutorialLink: "#",
    imageSrc: "https://docloo-public.lon1.cdn.digitaloceanspaces.com/group-young-business-people-working-office_158595-5218.avif"
  },
];

const Features06Page = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="max-w-screen-lg w-full py-10 px-6">
        <h2 className="text-4xl md:text-5xl md:leading-[3.5rem] font-black tracking-tight max-w-xl md:text-center md:mx-auto">
          Empower Your Business with Docloo
        </h2>
        <div className="mt-8 md:mt-16 w-full mx-auto space-y-20">
          {features.map((feature) => (
            <div
              key={feature.category}
              className="flex flex-col md:flex-row items-center gap-x-20 gap-y-6 md:odd:flex-row-reverse"
            >
              <div className="w-full aspect-[6/4] bg-muted rounded-xl border border-border/50 basis-1/2 overflow-hidden">
                <Image 
                  src={feature.imageSrc} 
                  alt={feature.category} 
                  width={800} 
                  height={450} 
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="basis-1/2 shrink-0">
                <span className="uppercase font-semibold tracking-tight">
                  {feature.category}
                </span>
                <h4 className="my-3 text-3xl font-bold tracking-tighter">
                  {feature.title}
                </h4>
                <p className="text-muted-foreground text-[17px]">
                  {feature.details}
                </p>
                <Button
                  asChild
                  className="mt-6 rounded-full min-w-40 text-[15px]"
                >
                  <Link href={feature.tutorialLink}>
                    Learn More <ArrowRight />
                  </Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features06Page;
